export const PRODUCTION = "production";
export const DEVELOPMENT = "development";
export const API_DEV_URL = "https://uat.trademo.com/trademo";
export const CLASSIFIER_API_URL = "https://uathsclassificationapi.trademo.com";
export const COMPLIANCE_API_URL = "https://uattdc.trademo.com/trademo";
export const GLOBAL_API_DEV_URL = "https://uatusermanagement.trademo.com/trademo";
export const LOCAL_ACCOUNTS_URL = "http://localhost:3002/";
export const LOCAL_INTEL_URL = "http://localhost:5173/";
export const LOCAL_SOURCE_ATLAS_URL = "http://localhost:5173/";
export const LOCAL_PAYMENTS_URL = "http://localhost:3004/";
export const LOCAL_COMPLIANCE_URL = "http://localhost:3012/";
export const LOCAL_SANCTIONS_URL = "http://localhost:3000/";
export const LOCAL_TRADE_MAP_URL = "http://localhost:3000";
export const LOCAL_HS_CODE_CLASSIFICATION_URL = "http://localhost:3025";
export const LOCAL_PRODUCT_MASTER_URL = "http://localhost:3017/";
export const LOCAL_USER_MANAGEMENT_SYSTEM_URL = "http://localhost:3020";
export const LOCAL_FIN_SCREENER = "http://localhost:3005";
